import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';


import Product from "api/Product";
import Category from "api/Category";


import ProductModel from 'models/Product';
import { connect } from "react-redux";
import {Add as ProductAddView} from 'views/product/Add';
import {
  MESSAGE_SUCCES,
	MESSAGE_INFO,
	SHOW_MAINMENU,
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import importScript from "hook/importScript";

class ProductAddController extends React.Component {
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,product: new ProductModel(), categories: false, validation: false, companyusers: false};
		this.initCategories = false;
		this.productApi = new Product();

const MyComponent = () => {
  importScript('path/to/my.js');
}
		
	}

	async componentDidMount() {
		const { dispatch } = this.props;

/*
    const script = document.createElement('script')
    script.src = "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDDvVKdECp3eMzK-A8AohqMeVKe5WUitOU"
    script.async = true
    document.body.appendChild(script)
*/
//		Google.getTestLocation();
		//importScript("https://www.google.nl/tesst.js");
		try {
					dispatch({type: SHOW_MAINMENU});

			dispatch(showLoader(false));
			const categoryApi = new Category();
			var t = await categoryApi.getCategories().then((response) =>   {
				return response.data.data;	
			});
			this.setState({categories: t});
			const {productid} = this.props;
//			if(productid) {
				var {product} = this.state;
				var productData = await this.productApi.getProductById(productid).then((response) =>   {
					return response.data;
				});
				if(productData.data.product) {
					product.addData(productData.data.product);
					this.setState({product: product});
				}
				if(productData.data.companyusers) {
					this.setState({companyusers: productData.data.companyusers});
				}
//			}
			dispatch(hideLoader());
		} catch(error) {
			dispatch(hideLoader());
		}		
	}
	

	
	onSaveHandler = (productData, photoHolder) => {
		const { dispatch } = this.props;
		try {	
			dispatch(showLoader());
			this.setState({isLoaded: true});	
			var response = this.productApi.addProduct(productData).then((response) =>   {
					var product = new ProductModel();
					product.addData(response.data.data.product);
					this.setState({isLoaded: false, product: product});
					dispatch({ type: MESSAGE_SUCCES, "message": "Het product is met succes opgeslagen op onze server", "header": "Product info" });
					dispatch(hideLoader());
					this.props.navigate('/products');
			}).catch((err) => {
				if(err.response.status == 422) {
					this.setState({validation: err.response.data.data, product: productData});
					dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
				}
				dispatch(hideLoader());
			});
	
				
		} catch(error) {
			dispatch(hideLoader());
		}				
		/*		
		this.productApi.addProduct(productData)
			.then((response) =>   {
				
			console.log("addproducts", response.data);
		})
		.catch((err) => {
			if(err.response.status == 422) {
				this.setState({validation: err.response.data.data});
				dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
			}
		});		
		*/
	}

	render() {
		const {categories,product, validation, companyusers } = this.state;
	return <ProductAddView initData={product} onSave={this.onSaveHandler} initCategories={categories} validation={validation} companyusers={companyusers} />;
	}

}

const ProductAddInit = (props) => {
    let { id } = useParams();
	let navigate = useNavigate();
	return (<ProductAddController {...props} productid={id} navigate={navigate}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn
  };
}

//export default (ProductAdd);

export default connect(mapStateToProps)(ProductAddInit);